// extracted by mini-css-extract-plugin
module.exports = {"imageTop":"QualityAssurance_imageTop__q2NDb","imageBottom":"QualityAssurance_imageBottom___C9DN"};